import { DataTable } from 'primereact/datatable'
import { CustomDataTableHeader, CustomModal } from '../../../../components'
import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { connect } from 'react-redux'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'

function ModalPosicaoRelatorioEstadia({ isVisible, onClose, posicaoId, selectedTp, dispatch }) {
  const [state, setState] = useState({
    posicoes: [],
    globalFilter: '',
    errorMessage: null,
  })

  useEffect(() => {
    if (isVisible) {
      EstoqueHttp.getProdutosFromPosicaoEstoqueForRelatorio(selectedTp, posicaoId)
        .then(res => setState(prevState => ({ ...prevState, posicoes: res })))
        .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
    }
  }, [isVisible])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({ ...prevState, errorMessage: null }))
    }
  }, [state.errorMessage])

  return (
    <CustomModal header="Produtos" isVisible={isVisible} onClose={onClose} width={700}>
      <DataTable
        value={state.posicoes}
        globalFilter={state.globalFilter}
        header={
          <CustomDataTableHeader
            value={state.globalFilter}
            onChange={value => setState(prevState => ({ ...prevState, globalFilter: value }))}
          />
        }
        paginator={true}
        rows={10}
      >
        <Column field="product_code" header="Código" style={tableCellCentered(120)} />
        <Column field="product_name" header="Produto" />
        <Column field="quantidade" header="Qte" style={tableCellCentered(80)} />
        <Column field="validade" header="Validade" style={tableCellCentered(100)} />
        <Column field="lote" header="Lote" style={tableCellCentered(100)} />
        <Column field="data_entrada" header="Data Entrada" style={tableCellCentered(100)} />
      </DataTable>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalPosicaoRelatorioEstadia)
